import React from 'react'
import { Box } from '@mui/material'
import TableData from '../atoms/table/TableData'
import ButtonCustom from '../atoms/button/ButtonCustom'
import KebabMenu from '../dataGrid/KebabMenu'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {
	getKazooFavoriteVendors,
	toggleFavoriteVendor,
} from '../../features/kazooEventSlice'

export default function FavoritesTable({ rows }) {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { kazooId } = useParams()
	const columns = [
		{
			field: 'businessName',
			headerName: 'Vendor',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'businessAddress',
			headerName: 'Location',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'action',
			headerName: 'Action',
			flex: 0,
			minWidth: 250,
			headerClassName: 'header-column-right',
			sortable: false,
			filterable: false,
			align: 'right',
			renderCell: (params) => {
				return (
					<div
						style={{
							display: 'flex',
							gap: '8px',
							alignItems: 'center',
							justifyContent: 'flex-end',
							height: '100%',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'flex-end',
								height: '100%',
								gap: '8px',
							}}
						>
							<ButtonCustom
								variant="outlined"
								size="sm"
								data-cy="kebab"
								onClick={(e) => openMenu(e, params.row)}
							>
								<img src="/images/more-horizontal.svg" alt="" />
							</ButtonCustom>
						</Box>
					</div>
				)
			},
		},
	]

	const [menuAnchor, setMenuAnchor] = React.useState(null)
	const [menuRow, setMenuRow] = React.useState(null)

	const openMenu = (e, row) => {
		e.stopPropagation()
		setMenuAnchor(e.currentTarget)
		setMenuRow(row)
	}

	const closeMenu = () => {
		setMenuAnchor(null)
		setMenuRow(null)
	}

	return (
		<div style={{ gridTemplateColumns: '1fr 1fr' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					// height: 'calc(100vh - 420px)',
					// height: '100%',
					// minHeight: 200,
					'@media (max-width: 900px)': {
						// height: 'calc(100vh - 390px)',
					},
				}}
			>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					<TableData
						rows={rows}
						columns={columns}
						height="75dvh"
						checkboxSelection={false}
					/>
				</Box>
				<KebabMenu
					anchorEl={menuAnchor}
					open={Boolean(menuAnchor)}
					onClose={closeMenu}
					items={[
						{
							key: 'view_profile',
							label: 'View Profile',
							icon: (
								<img
									src="/images/buliding.svg"
									alt="view_profile"
								/>
							),
							onClick: () => navigate(`/profile/${menuRow?.id}`),
						},
						{
							key: 'chat_now',
							label: 'Chat Now',
							icon: (
								<img
									src="/images/chat-icon.svg"
									alt="chat_now"
								/>
							),
							onClick: () => navigate(kazooId ? `/wedding/chat/${kazooId}` : `/chat`, { state: { selectedUser: { _id: menuRow?.id, businessName: menuRow?.businessName, profilePic: menuRow?.profilePic } } }),
						},
						{
							key: 'delete',
							label: 'Delete',
							icon: (
								<img
									src="/images/DeleteModal.svg"
									alt="delete"
								/>
							),
							onClick: () => {
								dispatch(
									toggleFavoriteVendor({
										kazooId,
										vendorId: menuRow?.id,
									})
								).then(() => {
									dispatch(getKazooFavoriteVendors(kazooId))
								})
								closeMenu()
							},
							color: 'error.main',
						},
					]}
				/>
			</Box>
		</div>
	)
}
